<template>
  <!--  -->
  <img src="@/assets/homehero_white.jpg" alt="hero" class="hero" />
</template>

<style scoped>
.hero {
  height: 100%;
  top: 0;
  left: 0;
}
</style>
